import React from "react";
import ReactDOM from "react-dom";
import "../../styles/modal.scss";
import { showModal, hideModal, ShowInfo, msg, genId, getValue, formId, getSource } from "../../components/utilities";
import { Section, SelectType, Textarea, Select, Count, Input } from "../../components/inputs";
import ModalHeader from "../../components/modalHeader";
import ModalFooter from "../../components/modalFooter";
import { Api as Keep } from "../../services/keep";
import { connect } from "react-redux";

class ModalTpActivity extends React.Component {
  constructor(props) {
    super(props);
    const data = this.handleScheme();
    this.state = {
      form: "__ModalTpActivity",
      _id: "__ModalTpActivity",
      title: "Actividad",
      rows: 15,
      show: false,
      old: data,
      data: data,
      _state: "0",
      references: {
        end: 0,
        all: 0,
      },
      printParams: {},
      activity_base: [
        { _id: -1, caption: "" },
        { _id: 0, caption: "Inventario" },
        { _id: 1, caption: "Instalación" },
        { _id: 2, caption: "Retiro" },
        { _id: 3, caption: "Cambio" },
        { _id: 4, caption: "Reposición" },
        { _id: 5, caption: "Baja" },
        { _id: 6, caption: "Perdida" },
        { _id: 7, caption: "Consumo de material" },
        { _id: 8, caption: "Taller" },
        { _id: 9, caption: "Mano de obra" },
      ],
      change: false,
    };
  }

  handleScheme = (e) => {
    return {
      project_id: this.props.project_id,
      _class: this.props._class,
      _state: "0",
      _id: genId("-1"),
      code: "",
      caption: "",
      description: "",
      _activity: 0,
      install: false,
      failure: false,
      running: false,
      reported: false,
      low: false,
      preventive: false,
      unitary: 0,
      _data: {},
      username: "",
    };
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
      change: true,
    });
  };

  handleChangeUnitary = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.name]: e.value,
      },
      change: true,
    });
  };

  handleChangeChk = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: Boolean(e.target.checked),
      },
      change: true,
    });
  };

  handleExecute = (e) => {
    const _state = this.props._state || "0";
    if (typeof this.props.onSetData === "function" && _state === '0') {
      this.props.onSetData(e);
    }
    this.handleHide();
  };

  handleHide = () => {
    hideModal(this.state._id);
    this.setState({ show: false });
  };

  handleShow = () => {
    if (this.props.isFind) {
      const _id = getValue(this.props, "_id", "-1");
      if (_id !== "-1") {
        const form_id = formId(`${this.state.form}${_id}`);
        this.setState({ _id: form_id, show: true, change: false });
      }
    } else if (this.props.isNew) {
      const form_id = `${this.state.form}${Date.now()}`;
      this.setState({ _id: form_id, show: true, change: false });
    } else {
      const _id = getValue(this.props.data, "_id", "-1");
      if (_id !== "-1") {
        const form_id = formId(`${this.state.form}${_id}`);
        this.setState({ _id: form_id, show: true, change: false });
      }
    }
  };

  handleClose = (e) => {
    if (this.state.change && e) {
      this.handleOk();
    } else {
      this.handleHide();
    }
  };

  handleOk = () => {
    if (this.state.change) {
      const id = this.state.data._id;
      const params = this.state.data;
      Keep.setTypeActivity(id, params).then((result) => {
        if (result.msg === "") {
          let data = result.data;
          this.handleSetData({ data, isNew: false, change: false, focusInt: false });
          this.handleExecute(result.data);
        }
      });
    } else {
      this.handleHide();
    }
  };

  handleFinish = (e) => {
    if (e) {
      const id = this.state.data._id;
      Keep.stateTypeActivity(id, "1").then((result) => {
        if (result.msg === "") {
          this.handleExecute(result.data);
          this.handleHide();
        }
      });
    }
  };

  handleRestore = (e) => {
    if (e) {
      const id = this.state.data._id;
      Keep.stateTypeActivity(id, "0").then((result) => {
        if (result.msg === "") {
          this.handleExecute(result.data);
        }
      });
    }
  };

  handleSetData = (e) => {
    this.setState({
      old: e.data,
      data: e.data,
      isNew: e.isNew,
      change: e.change,
      tabs: [],
      printParams: {
        project_id: e.data.project_id,
        _class: e.data._class,
        single: true,
      },
    });
    showModal(this.state._id);
  };

  handleData = () => {
    const _id = getSource(this.props.data, ["_id"], "-1");
    if (_id === "-1") {
      this.handleSetData({ data: this.props.data, isNew: false, change: false });
    } else {
      this.handleFind(_id);
    }
  };

  handleNew = () => {
    const data = this.handleScheme();
    this.handleSetData({ data, isNew: true, change: true });
  };

  handleFind = (id) => {
    if (this.state.change) {
      ShowInfo(msg("MSG-CHANGE"));
    } else if (id !== "-1") {
      Keep.typeactivity(id, this.props.project_id).then((result) => {
        if (result.msg === "") {
          const data = result.data;
          this.handleSetData({ data, isNew: false, change: false });
        }
      });
    }
  };

  handleAccountant = (e) => {
    this.setState({ references: e });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.show) {
      if (prevState.show !== this.state.show) {
        if (this.props.isNew) {
          this.handleNew();
        } else if (this.props.isFind) {
          this.handleFind(this.props._id);
        } else {
          this.handleData();
        }
      }
    }
  }

  componentWillUnmount() {
    hideModal(this.state._id);
  }

  render() {
    if (!this.state.show) {
      return (
        <React.Fragment>
          <div className={this.props.className} onClick={this.handleShow} disabled={!(this.props._state === "0" || !this.props._state)}>
            {this.props.children}
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className={this.props.className} onClick={this.handleShow} disabled={!(this.props._state === "0" || !this.props._state)}>
            {this.props.children}
          </div>
          {ReactDOM.createPortal(
            <div className="modal fade" id={this.state._id} role="dialog">
              <div className="modal-dialog xs __modalObject" role="dialog">
                <div className="modal-content">
                  <ModalHeader title={this.state.title} handleClose={this.handleClose} />
                  <div className="modal-body-tabs" style={{ height: "460px" }}>
                    <nav>
                      <div className="nav nav-tabs" role="tablist">
                        <a
                          className="nav-item nav-link active"
                          id={`${this.state._id}-nav-1-tab`}
                          data-toggle="tab"
                          href={`#${this.state._id}-nav-1`}
                          role="tab"
                          aria-selected="true"
                        >
                          General
                        </a>
                        <a
                          className="nav-item nav-link"
                          id={`${this.state._id}-nav-2-tab`}
                          data-toggle="tab"
                          href={`#${this.state._id}-nav-2`}
                          role="tab"
                          aria-selected="false"
                        >
                          Detalle
                        </a>
                      </div>
                    </nav>
                    <div className="tab-content modal not-scroll">
                      <div
                        className="tab-pane fade show active"
                        id={`${this.state._id}-nav-1`}
                        role="tabpanel"
                        aria-labelledby={`${this.state._id}-nav-1-tab`}
                      >
                        <div className="row">
                          <div className="col-12">
                            <div className="form-group input-group-sm">
                              <label>Tipo</label>
                              <SelectType
                                className="form-control"
                                _state={this.state.data._state}
                                projectId={this.props.project_id}
                                _class="KEEP_TYPE_ACTIVITY"
                                name="_class"
                                value={this.state.data._class}
                                onChange={this.handleChange}
                              />
                            </div>
                            <div className="form-group input-group-sm">
                              <label>Nombre</label>
                              <Section
                                id={`${this.state._id}_caption`}
                                type="text"
                                className="form-control name"
                                placeholder="Nombre"
                                _state={this.state.data._state}
                                name="caption"
                                value={this.state.data.caption}
                                onChange={this.handleChange}
                              />
                            </div>
                            <div className="form-group input-group-sm">
                              <label>Descripción</label>
                              <Textarea
                                className="form-control notresize"
                                placeholder="description"
                                rows={4}
                                _state={this.state.data._state}
                                name="description"
                                value={this.state.data.description}
                                onChange={this.handleChange}
                              />
                            </div>
                            <div className="form-group input-group-sm">
                              <label>Actividad basica</label>
                              <Select
                                className="form-control"
                                _state={this.state.data._state}
                                name="_activity"
                                value={this.state.data._activity}
                                onChange={this.handleChange}
                                list={this.state.activity_base}
                              />
                            </div>
                            <div className="form-row input-group-sm mb-0">
                              <div className="form-group col-md-5 input-group-sm mb-0">
                                <label>Código</label>
                                <Input
                                  type="text"
                                  className="form-control"
                                  placeholder="Código"
                                  _state={this.state.data._state}
                                  name="code"
                                  value={this.state.data.code}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <div className="form-group col-md-7 input-group-sm mb-0">
                              <label>Unitario</label>
                              <Count
                                className="input-group input-group-sm"
                                _state={this.state.data._state}
                                name="unitary"
                                unity="$"
                                value={this.state.data.unitary}
                                increase={1000}
                                precision={0}
                                handleValue={this.handleChangeUnitary}
                              />
                            </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade show"
                        id={`${this.state._id}-nav-2`}
                        role="tabpanel"
                        aria-labelledby={`${this.state._id}-nav-2-tab`}
                      >
                        <div className="row">
                          <div className="col-12">
                            <div className="form-group input-group-sm">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  disabled={!(this.state.data._state === "0")}
                                  id={`${this.state._id}_Checkbox1`}
                                  name="install"
                                  checked={this.state.data.install}
                                  onChange={this.handleChangeChk}
                                />
                                <label className="form-check-label" htmlFor={`${this.state._id}_Checkbox1`}>
                                  Instalada
                                </label>
                              </div>
                            </div>
                            <div className="form-group input-group-sm">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  disabled={!(this.state.data._state === "0")}
                                  id={`${this.state._id}_Checkbox2`}
                                  name="failure"
                                  checked={this.state.data.failure}
                                  onChange={this.handleChangeChk}
                                />
                                <label className="form-check-label" htmlFor={`${this.state._id}_Checkbox2`}>
                                  En falla
                                </label>
                              </div>
                            </div>
                            <div className="form-group input-group-sm">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  disabled={!(this.state.data._state === "0")}
                                  id={`${this.state._id}_Checkbox3`}
                                  name="running"
                                  checked={this.state.data.running}
                                  onChange={this.handleChangeChk}
                                />
                                <label className="form-check-label" htmlFor={`${this.state._id}_Checkbox3`}>
                                  En funcionamiento
                                </label>
                              </div>
                            </div>
                            <div className="form-group input-group-sm">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  disabled={!(this.state.data._state === "0")}
                                  id={`${this.state._id}_Checkbox4`}
                                  name="reported"
                                  checked={this.state.data.reported}
                                  onChange={this.handleChangeChk}
                                />
                                <label className="form-check-label" htmlFor={`${this.state._id}_Checkbox4`}>
                                  Reportar
                                </label>
                              </div>
                            </div>
                            <div className="form-group input-group-sm">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  disabled={!(this.state.data._state === "0")}
                                  id={`${this.state._id}_Checkbox5`}
                                  name="low"
                                  checked={this.state.data.low}
                                  onChange={this.handleChangeChk}
                                />
                                <label className="form-check-label" htmlFor={`${this.state._id}_Checkbox5`}>
                                  Dar de baja
                                </label>
                              </div>
                            </div>
                            <div className="form-group input-group-sm">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  disabled={!(this.state.data._state === "0")}
                                  id={`${this.state._id}_Checkbox5`}
                                  name="preventive"
                                  checked={this.state.data.preventive}
                                  onChange={this.handleChangeChk}
                                />
                                <label className="form-check-label" htmlFor={`${this.state._id}_Checkbox5`}>
                                  Programar mantenimiento preventivo
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <ModalFooter
                      single="Actividad"
                      plural="la actividad"
                      project_id={this.state.data.project_id}
                      _state={this.state.data._state}
                      change={this.state.change}
                      onFinish={this.handleFinish}
                      onRestore={this.handleRestore}
                      onClose={this.handleClose}
                      onOk={this.handleOk}
                    />
                  </div>
                </div>
              </div>
            </div>,
            document.getElementById("rootModals")
          )}
        </React.Fragment>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    signin: state.sistem.signin,
    project_id: state.sistem.project._id || "-1",
    project: state.sistem.project,
    _view: state.sistem.folder._view || "",
    online: state.sistem.online,
  };
}

export default connect(mapStateToProps)(ModalTpActivity);
